import React from 'react';
import { IUser } from '../../../Interfaces/responseTypes';
import { useAvatarHooks } from '../avatar-hooks';
import styles from './userAvatar.module.scss';

interface IProps {
    user: IUser,
}

const UserAvatar: React.FC<IProps> = ({ user}) => {
    const { circleText, avatarText } = useAvatarHooks(user!);

    return (
        <>
            <div className={`${styles.container}`} >
                <div className={styles.circle}>
                    <p>{circleText}</p>
                </div>
                <p className={styles.avatarText}>
                    {avatarText}
                </p>
            </div>
            <div style={{ position: 'fixed' }}>
            </div>
        </>
    )
}

export default UserAvatar
